import React from 'react';
import './index.scss';

export const { Provider: CondorLayoutProvider, Consumer } =
  React.createContext();
